import React from 'react'

import PlansPage from './PlansPage'
import plansLoader from './plans.loader'

import type { RouteObject } from 'react-router-dom'

const plansRoutes: RouteObject[] = [{ index: true, element: <PlansPage />, loader: plansLoader }]

export default plansRoutes
